module.exports = __webpack_public_path__ + "img/question18c3.fb3fb8eb.png";